import React, { useState } from "react";
import { Page } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { QrForm } from "../components";
import { useNavigate } from "react-router-dom";

export default function QrCreate({ shopDomain: shopDomain, user: user }) {
  let navigate = useNavigate();
  const breadcrumbs = [
    { content: "QR codes", onAction: () => navigate("/api/shopify/") },
  ];
  const [breadcrumbTitle, setBreadcrumbTitle] = useState("Create new QR code");

  return (
    <Page>
      <TitleBar
        title={breadcrumbTitle}
        breadcrumbs={breadcrumbs}
        primaryAction={null}
      />
      <QrForm
        shopDomain={shopDomain}
        setStateBreadcrumbTitle={setBreadcrumbTitle}
        user={user}
      />
    </Page>
  );
}
